import { generateCrudApi } from "helpers/crudGeneratorExtend";
export const medicationsApi = generateCrudApi({ name: "medications" });
